import { getPublicImagePath, STATIC_IMAGES } from "@/config/images"
import Image from "next/image"
import Link from "next/link"
import React from "react"

interface AppTitleProps {
  showLabel?: boolean
  size?: "sm" | "md" | "lg"
  className?: string
}

/**
 * Composant titre de l'application avec logo UIC et label "Booklet"
 * Suit les best practices Next.js pour les composants réutilisables
 */
const AppTitle: React.FC<AppTitleProps> = ({
  showLabel = true,
  size = "md",
  className = "",
}) => {
  const sizeConfig = {
    sm: {
      logoHeight: 20,
      logoWidth: 100,
      textSize: "text-lg",
      gap: "gap-2",
    },
    md: {
      logoHeight: 40,
      logoWidth: 180,
      textSize: "text-lg",
      gap: "gap-2",
    },
    lg: {
      logoHeight: 24,
      logoWidth: 60,
      textSize: "text-lg",
      gap: "gap-2",
    },
  }[size]

  return (
    <Link
      href="/"
      className={`flex items-center ${sizeConfig.gap} transition-opacity hover:opacity-80 ${className}`}
      aria-label={`${process.env.NEXT_PUBLIC_APP_NAME} - Home`}
    >
      <Image
        src={getPublicImagePath(STATIC_IMAGES.APP_LOGO || 'sustainability-hub.svg')}
        alt="Sustainability Hub Logo"
        width={sizeConfig.logoWidth}
        height={sizeConfig.logoHeight}
        priority
        className="p-1"
      />

      {showLabel && (
        <span
          className={`${sizeConfig.textSize} text-foreground font-semibold tracking-tight`}
        >
          {process.env.NEXT_PUBLIC_APP_NAME}
        </span>
      )}
    </Link>
  )
}

AppTitle.displayName = "AppTitle"

export default AppTitle
